import TextField, {TextFieldProps} from "@mui/material/TextField";
import React, {useState} from "react";
import isEmail from "validator/es/lib/isEmail";

/**
 * @param props
 * @constructor
 */
export const XTextField = (props: TextFieldProps) => {
    const [error, setError] = useState(false)

    const errorText = () => {
        switch (props.type) {
            case "email":
                return "Courriel invalide (ex: test@exemple.com)"
            default:
                return ""
        }
    }

    const onBlurValidation = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        // 1 - check for required
        if (props.required && e.target.value == "")
            setError(true)
        else
            setError(false)

        // 2 - then check if proper type of data is there
        switch (props.type) {
            case "email":
                if (!isEmail(e.target.value))
                    setError(true)
                else
                    setError(false)
        }
    }

    return <TextField
        variant={props.variant ?? "outlined"}
        size={props.size ?? "small"}
        helperText={error && errorText()}
        error={error}
        onBlur={onBlurValidation}
        {...props}
    ></TextField>
}